var map = {
	"./adia_logo.jpeg": "8ec9",
	"./arrow-right.svg": "cd8c",
	"./assessments/24-support.svg": "f600",
	"./assessments/briefcase.svg": "c209",
	"./assessments/frame.svg": "aef8",
	"./assessments/ghost.svg": "a8de",
	"./assessments/message-question.svg": "37f3",
	"./assessments/profile-2user.svg": "ab11",
	"./assessments/smileys.svg": "dffb",
	"./assessments/story.svg": "8a99",
	"./assessments/teacher.svg": "99a6",
	"./bold/add-circle.svg": "bc3d",
	"./bold/add-colored.svg": "143b",
	"./bold/arrow-right.svg": "f415",
	"./bold/award.svg": "619e",
	"./bold/briefcase.svg": "e75e",
	"./bold/brifecase-tick.svg": "4c1d",
	"./bold/buildings.svg": "b6f8",
	"./bold/camera.svg": "5712",
	"./bold/clipboard.svg": "3f57",
	"./bold/cloud-connection.svg": "f2c0",
	"./bold/crown.svg": "f71c",
	"./bold/cup.svg": "5c17",
	"./bold/devices.svg": "7bdc",
	"./bold/document-text.svg": "eae2",
	"./bold/document-upload.svg": "9909",
	"./bold/external-drive.svg": "1c8d",
	"./bold/flag.svg": "e1c0",
	"./bold/flash.svg": "ab72",
	"./bold/ghost.svg": "bc74",
	"./bold/info-circle.svg": "960c",
	"./bold/keyboard-open.svg": "a635",
	"./bold/layer.svg": "dc09",
	"./bold/link-square.svg": "b702",
	"./bold/location.svg": "ac4d",
	"./bold/lock.svg": "4ce0",
	"./bold/messages.svg": "5ce0",
	"./bold/microphone.svg": "fdf4",
	"./bold/mobile.svg": "906e",
	"./bold/monitor-mobile.svg": "e166",
	"./bold/notice-period.svg": "b4b2",
	"./bold/pen-tool-2.svg": "4435",
	"./bold/people.svg": "0520",
	"./bold/personalcard.svg": "755f",
	"./bold/recovery-convert.svg": "b0da",
	"./bold/refresh.svg": "95ba",
	"./bold/reset.svg": "1686",
	"./bold/ruler&pen.svg": "0bd3",
	"./bold/salary.svg": "195a",
	"./bold/send.svg": "ed77",
	"./bold/simcard.svg": "0f15",
	"./bold/sms.svg": "d937",
	"./bold/star.svg": "263f",
	"./bold/trash.svg": "badf",
	"./bold/triangle.svg": "0658",
	"./bold/user-octagon.svg": "34d9",
	"./bold/video-circle.svg": "2430",
	"./direction-left.svg": "cdb7",
	"./direction-right.svg": "85ec",
	"./document-download.svg": "8902",
	"./ellipse.svg": "4e7f",
	"./fab_logo.jpeg": "e426",
	"./facebook.svg": "8485",
	"./file-uploader.svg": "8d50",
	"./indeed1.svg": "8ce2",
	"./job/icon.svg": "0830",
	"./job/icon1.svg": "4440",
	"./job/icon2.svg": "10cb",
	"./job/icon3.svg": "0c3b",
	"./ku_logo.jpeg": "256b",
	"./ku_logo.png": "dfc0",
	"./linear/add-candidate.svg": "16bd",
	"./linear/arrow-circle-right.svg": "7bcd",
	"./linear/arrow-left-1.svg": "e841",
	"./linear/arrow-left.svg": "75ef",
	"./linear/bot.svg": "5dfd",
	"./linear/calendar-edit.svg": "d12e",
	"./linear/circle-empty.svg": "0d57",
	"./linear/circle-full.svg": "4b66",
	"./linear/direction-down.svg": "77c1",
	"./linear/document-copy.svg": "8003",
	"./linear/document-download.svg": "434c",
	"./linear/document-forward.svg": "d308",
	"./linear/document-upload.svg": "d296",
	"./linear/dropdown.svg": "d54b",
	"./linear/e-learning.svg": "5c5b",
	"./linear/edit.svg": "0f32",
	"./linear/exam.svg": "c4af",
	"./linear/eye.svg": "4101",
	"./linear/file-search.svg": "07b1",
	"./linear/filter.svg": "f2fe",
	"./linear/flag.svg": "2500",
	"./linear/global-edit.svg": "fa80",
	"./linear/heart.svg": "4634",
	"./linear/interactive.svg": "5e29",
	"./linear/keyboard-open.svg": "3bf8",
	"./linear/left-arrow.svg": "3cef",
	"./linear/link.svg": "09d8",
	"./linear/menu-list.svg": "b236",
	"./linear/microphone-close.svg": "c880",
	"./linear/microphone-disabled.svg": "153e",
	"./linear/microphone.svg": "b4c0",
	"./linear/mouse-square.svg": "befc",
	"./linear/notification.svg": "c612",
	"./linear/ocean-white.svg": "bf3a",
	"./linear/ocean.svg": "290c",
	"./linear/plus.svg": "c7a8",
	"./linear/right-arrow.svg": "f949",
	"./linear/setting.svg": "e45d",
	"./linear/share.svg": "69df",
	"./linear/sms-edit.svg": "f940",
	"./linear/speed-test.svg": "da30",
	"./linear/students.svg": "ccaa",
	"./linear/tick-circle-1.svg": "d1c6",
	"./linear/tick-circle.svg": "83a1",
	"./linear/tick-double.svg": "aeda",
	"./linear/users.svg": "ae5d",
	"./linkedin.svg": "9ed9",
	"./mubadla_logo.jpeg": "f666",
	"./nav_sidebar/active/approvals.svg": "b478",
	"./nav_sidebar/active/assessment.svg": "e673",
	"./nav_sidebar/active/candidates.svg": "1fab",
	"./nav_sidebar/active/courses.svg": "0601",
	"./nav_sidebar/active/dashboard.svg": "cdfc",
	"./nav_sidebar/active/employees.svg": "d85d",
	"./nav_sidebar/active/jobs.svg": "b162",
	"./nav_sidebar/active/knowledge-base.svg": "d34b",
	"./nav_sidebar/active/settings.svg": "4ef7",
	"./nav_sidebar/active/teacher.svg": "c394",
	"./nav_sidebar/approvals.svg": "3b1a",
	"./nav_sidebar/assessment.svg": "b32b",
	"./nav_sidebar/candidates.svg": "598b",
	"./nav_sidebar/courses.svg": "ad05",
	"./nav_sidebar/dashboard.svg": "bff1",
	"./nav_sidebar/employees.svg": "5d73",
	"./nav_sidebar/jobs.svg": "db19",
	"./nav_sidebar/knowledge-base.svg": "b00c",
	"./nav_sidebar/settings.svg": "41c3",
	"./nav_sidebar/teacher.svg": "0c65",
	"./star-fill.svg": "c0e7",
	"./swipe-left.svg": "5842",
	"./swipe-right.svg": "218e",
	"./twitter.svg": "acf9",
	"./whatsapp.svg": "7583"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";